<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23C18.299 23 23 18.299 23 12.5C23 6.70101 18.299 2 12.5 2C6.70101 2 2 6.70101 2 12.5C2 18.299 6.70101 23 12.5 23ZM18.4984 8.29513L13.4969 5.41953C12.8797 5.06468 12.1203 5.06468 11.5031 5.41953L6.50157 8.29513C6.19128 8.47352 6 8.80414 6 9.16206V15.5771C6 16.3283 6.42094 17.0162 7.08986 17.358L12.0449 19.8903C12.3307 20.0364 12.6693 20.0364 12.9551 19.8903L17.9101 17.358C18.5791 17.0162 19 16.3283 19 15.5771V9.16206C19 8.80414 18.8087 8.47352 18.4984 8.29513ZM12.5 7.15339L15.9037 9.11034L12.5 10.8498L9.09625 9.11034L12.5 7.15339ZM13.5 12.5848L17 10.7961V15.5771L13.5 17.3658V12.5848ZM11.5 12.5848V17.3658L8 15.5771V10.7961L11.5 12.5848Z"
      fill="currentColor"
    />
  </svg>
</template>
